import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WebStorage, WebStorageNames } from "../../../utils";
import "../documents/Documents.css";
import "./TimeLogProjectsGuidanceModal.css";

const getModalRoleId = () => {
  const r = WebStorage.getLocalStore(WebStorageNames.RoleId) ?? localStorage.getItem("roleId");
  const n = parseInt(String(r), 10);
  return Number.isFinite(n) ? n : null;
};

const isAdminRole = (roleId) => roleId === 1 || roleId === 2;

/**
 * @param {{
 *   open: boolean;
 *   onClose: () => void;
 *   situation: import("./timesheetProjectGuidance").TimelogProjectSituation | null;
 * }} props
 */
const TimeLogProjectsGuidanceModal = ({ open, onClose, situation }) => {
  const { t } = useTranslation();
  const history = useHistory();

  if (!open || !situation || situation.kind === "ok") return null;

  const roleId = getModalRoleId();
  const admin = isAdminRole(roleId);

  const titleKey =
    situation.kind === "no_projects"
      ? (admin ? "titleNoProjects" : "titleNoProjectsNonAdmin")
      : situation.kind === "not_assigned"
        ? "titleNotAssigned"
        : "titleBlocked";

  const leadKey =
    situation.kind === "no_projects"
      ? (admin ? "leadNoProjects" : "leadNoProjectsNonAdmin")
      : situation.kind === "not_assigned"
        ? (admin ? "leadNotAssigned" : "leadNotAssignedNonAdmin")
        : (admin ? "leadBlocked" : "leadBlockedNonAdmin");

  const goToProjects = () => {
    onClose();
    history.push("/settings/organization/projects");
  };

  return (
    <div
      className="documents-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="timelog-projects-guidance-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="documents-modal documents-modal--upload-single timelog-projects-guidance-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="documents-modal-preview timelog-projects-guidance-modal__body">
          <div className="documents-upload-modal-header">
            <div>
              <p className="documents-upload-modal-eyebrow">
                {t(admin ? "app.timesheets.entry.projectsGuidance.eyebrow" : "app.timesheets.entry.projectsGuidance.eyebrowNonAdmin")}
              </p>
              <h2 className="documents-upload-modal-title" id="timelog-projects-guidance-title">
                {t(`app.timesheets.entry.projectsGuidance.${titleKey}`)}
              </h2>
            </div>
            <button
              type="button"
              className="btn btn-light documents-btn"
              aria-label={t("app.common.close")}
              onClick={onClose}
            >
              {t("app.common.close")}
            </button>
          </div>

          <div className="documents-modal-sheet documents-modal-sheet--upload">
            <div className="timelog-projects-guidance-modal__summary">
              <div className="timelog-projects-guidance-modal__icon-wrap" aria-hidden>
                <i className={admin ? "bi bi-kanban" : "bi bi-info-circle"} />
              </div>
              <div>
                <p className="timelog-projects-guidance-modal__lead">{t(`app.timesheets.entry.projectsGuidance.${leadKey}`)}</p>
                {admin ? (
                  <>
                    <p className="timelog-projects-guidance-modal__hint">{t("app.timesheets.entry.projectsGuidance.hint")}</p>
                    <ul className="timelog-projects-guidance-modal__list">
                      <li>{t("app.timesheets.entry.projectsGuidance.tipCheckStatus")}</li>
                      <li>{t("app.timesheets.entry.projectsGuidance.tipOnHoldInactive")}</li>
                      <li>{t("app.timesheets.entry.projectsGuidance.tipTeamAssignment")}</li>
                    </ul>
                  </>
                ) : (
                  <p className="timelog-projects-guidance-modal__hint">{t("app.timesheets.entry.projectsGuidance.hintNonAdmin")}</p>
                )}
              </div>
            </div>

            <div className="timelog-projects-guidance-modal__actions">
              <button type="button" className="btn btn-light documents-btn" onClick={onClose}>
                {t("app.timesheets.entry.projectsGuidance.dismiss")}
              </button>
              {admin && (
                <button
                  type="button"
                  className="btn documents-btn documents-btn--primary-workplace timelog-projects-guidance-modal__cta"
                  onClick={goToProjects}
                >
                  <i className="bi bi-kanban me-2" aria-hidden />
                  {t("app.timesheets.entry.projectsGuidance.goToProjects")}
                  <i className="bi bi-arrow-right ms-2 timelog-projects-guidance-modal__cta-arrow" aria-hidden />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeLogProjectsGuidanceModal;
